import {
  BlockIcon,
  MarketplaceIcon,
  ManageAppsIcon,
  SettingsIcon,
  SystemIcon,
  UserGroupIcon,
  UserIcon,
  BrandIcon,
} from "@components/icons";
import "./left-menu.scss";
import { NavLink } from "react-router-dom";
import { memo } from "react";
import { Permission } from "@contexts/permissions.context";
import { PermissionTypes } from "@archetypes/gql";

const LeftMenuComponent = () => {
  return (
    <aside className="left-menu">
      <span className="brand-icon">
        <BrandIcon size="30" color="#ffffff" />
      </span>

      <ul className="menu-items">
        <Permission access={[PermissionTypes.APP_READ]}>
          <li>
            <NavLink to="/builder/apps">
              <span className="icon">
                <ManageAppsIcon color="#ffffff" />
              </span>
              <span className="nav-label"> Apps</span>
            </NavLink>
          </li>
        </Permission>
        <Permission access={[PermissionTypes.CATEGORY_READ]}>
          <li>
            <NavLink to="/builder/categories">
              <span className="icon">
                <BlockIcon color="#ffffff" />
              </span>
              <span className="nav-label"> Categories</span>
            </NavLink>
          </li>
        </Permission>
        <Permission access={[PermissionTypes.USER_READ]}>
          <li>
            <NavLink to="/builder/users">
              <span className="icon">
                <UserIcon color="#ffffff" />
              </span>
              <span className="nav-label"> Users</span>
            </NavLink>
          </li>
        </Permission>
        <Permission access={[PermissionTypes.GROUP_READ]}>
          <li>
            <NavLink to="/builder/groups">
              <span className="icon">
                <UserGroupIcon color="#ffffff" />
              </span>
              <span className="nav-label"> Groups</span>
            </NavLink>
          </li>
        </Permission>
        <Permission access={[PermissionTypes.MARKETPLACE_READ]}>
          <li>
            <NavLink to="/builder/market-place">
              <span className="icon">
                <MarketplaceIcon color="#ffffff" />
              </span>
              <span className="nav-label">Marketplace</span>
            </NavLink>
          </li>
        </Permission>
        <Permission access={[PermissionTypes.ENTITY_READ]}>
          <li>
            <NavLink to="/builder/entities" className="entity">
              <span className="icon">
                <SystemIcon color="#ffffff" />
              </span>
              <span className="nav-label"> Entities</span>
            </NavLink>
          </li>
        </Permission>
        <li>
          <NavLink to="/builder/settings/profile">
            <span className="icon">
              <SettingsIcon color="#ffffff" />
            </span>
            <span className="nav-label"> Settings</span>
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export const LeftMenu = memo(LeftMenuComponent);
